import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const names = ['María G.', 'Lucas P.', 'Sofía R.', 'Martín C.', 'Camila L.', 'Diego M.', 'Florencia S.', 'Agustín V.', 'Valentina B.', 'Tomás D.', 'Julieta F.', 'Matias N.', 'Lucía H.', 'Facundo T.', 'Micaela A.'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'San Juan', 'Santa Fe', 'Posadas', 'Resistencia', 'Bahía Blanca'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomNotification = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 minutes ago
    setNotification({
      name: randomName,
      city: randomCity,
      time: `hace ${randomTime} minuto${randomTime > 1 ? 's' : ''}`
    });
    setIsVisible(true);
    // Hide after 6 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 15 and 25 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      setTimeout(() => {
        showRandomNotification();
      }, nextDelay);
    }, 6000);
  };
  return <AnimatePresence data-id="element-285">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-2xl shadow-2xl border border-brand-100 p-4 flex gap-4 items-start" data-id="element-286">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-brand-400 hover:text-brand-600 transition-colors" data-id="element-287">
            <X className="w-4 h-4" data-id="element-288" />
          </button>

          <div className="w-12 h-12 rounded-full bg-brand-50 flex items-center justify-center shrink-0 border border-brand-100" data-id="element-289">
            <span className="text-brand-700 font-bold text-lg" data-id="element-290">
              {notification.name.charAt(0)}
            </span>
          </div>

          <div className="flex-1 pr-4" data-id="element-291">
            <p className="text-sm text-brand-900 leading-tight mb-1" data-id="element-292">
              <span className="font-bold" data-id="element-293">{notification.name}</span> de{' '}
              {notification.city} acaba de comprar{' '}
              <span className="font-bold text-accent-600" data-id="element-294">
                Profe Coreano Pro
              </span>
            </p>
            <div className="flex items-center gap-1.5 text-xs text-brand-500 font-medium" data-id="element-295">
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-296" />
              <span data-id="element-297">Compra verificada • {notification.time}</span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}